import { MarkSpec } from 'prosemirror-model';

import { BaseExtension, extensionType } from '@lyearn/lygo-core';

class EmojiMark extends BaseExtension {
  get schema(): MarkSpec {
    return {
      inclusive: false,
      parseDOM: [{ tag: 'span.emoji' }],
      toDOM: () => ['span', { class: 'emoji' }, 0],
    };
  }

  get type(): string {
    return extensionType.mark;
  }

  get name(): string {
    return 'emoji';
  }
}

export default EmojiMark;
